import { selectedRowColor, unSelectedRowColor , whiteColor, grayColor} from 'assets/jss/material-dashboard-pro-react';

const fbbTableStyle = (theme) => ({
	commitmentWrapper: {
		marginTop: '20px'
	},
	colorWhite: {
		color: `${whiteColor} !important`
	},
	radioButtons: {
		display: 'inline-flex',
		width: 500,
		[theme.breakpoints.down('xs')]: {
			display: 'inline-block',
			width: '100%',
			marginLeft: 15,
		},
	},
	commitmentSelection: {
		display: 'inline-flex',
		width: '600px',
		paddingLeft: 15,
		[theme.breakpoints.down('xs')]: {
			display: 'inline-block',
			width: '100%',
		},
	},
	radioContainer: {
		flex: 1,
	},
	servicePicker: {
		[theme.breakpoints.down('sm')]: {
			width: 1000,
		},
	},
	servicePickerWrapper: {
		[theme.breakpoints.down('sm')]: {
			overflow: 'auto',
		},
	},
	disabled : {
		'& .MuiTableCell-root': {
			pointerEvents:'none',
			backgroundColor: grayColor[1],
		}
	},
	selectedRow: {
		'& .MuiTableCell-root': {
			backgroundColor: selectedRowColor,
		}
	},
	unSelectedRow: {
		// '& .MuiTableCell-root:nth-child(2)': {
		// 	backgroundColor: unSelectedRowColor
		// }
	},
	pullLeft: {
		marginLeft: '-60px'
	},
	marginTop: {
		marginTop:'10px'
	}
	
});

export default fbbTableStyle;
